<template>

	  <ConfirmDialogue ref="confirmDialogue" />
  	<MessageDialogue ref="messageDialogue" />

  	<inner-template :breadcrumbs="breadcrumbs">

	  	<div class="component-content">

	  		<!-- Заголовки колонок -->
				<div class="component-headers" v-if="counter !== null">
					<div class="component-headers__item">
						<div class="component-header component-header--red">
							<div class="component-header__label">Новые</div>
							<div class="component-header__badge"> {{ counter.signal_true }} </div>
						</div>
					</div>
					<div class="component-headers__item">
						<div class="component-header component-header--blue">
							<div class="component-header__label">Обработанные</div>
							<div class="component-header__badge"> {{ counter.signal_false }} </div>
						</div>
					</div>
				</div>

				<!-- Прока загрузка -->
	  		<div class="load-container load" v-if="isLoad"></div>

				<!-- Канбан по задачам -->
	  		<div class="component-tasks" v-if="!isLoad">
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<SignalPreview 
	    					v-for="signal in signals.StatusTrue" 
	    					:signal="signal" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id" 
	    					:key="signal.id"
	    					@createTask="()=>{ loadSignals() }"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'StatusTrue')" 
	    					v-if="signals.StatusTrue.length > 0 && maxSignalCategory.indexOf('StatusTrue') == -1">
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	  				</div>
	  			</div>
	  			<div class="component-tasks__item">
	  				<div class="component-tasks__content">
	    				<SignalPreview 
	    					v-for="signal in signals.StatusFalse" 
	    					:signal="signal" 
	    					:organization_id="organization_id" 
	    					:house_id="house_id"
	    					:key="signal.id"
	    					@createTask="()=>{ loadSignals() }"
	    				/>
	    				<a 
	    					class="btn btn--md btn--outline-dashed btn--inline mt-1" 
	    					@click="uploading($event, 'StatusFalse')" 
	    					v-if="signals.StatusFalse.length > 0 && maxSignalCategory.indexOf('StatusFalse') == -1">
	    					<div class="btn--text">Показать больше</div>
	    					<div class="btn--loader"></div>
	    				</a>
	    			</div>
	  			</div>
	  		</div>

	  	</div>

  	</inner-template>

</template>

<script setup>
  import SignalPreview from '@/components/tracker/SignalPreview.vue';
  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';
  import InnerTemplate from '@/components/tracker/InnerTemplate.vue';
</script>

<script>

  export default {

    name: 'PageTrackerHouseSignals',

		data: () => ({
      // Страница
      isLoad: true,

      breadcrumbs: [],
      address: null,
      counter: null,

      limit: 10,
      limitPreLoad: 10,
      
      // Справочники
      signals: [],
      maxSignalCategory: [],

    }),


    computed: {
    	house_id () {
        return this.$route.params.house_id;
      },
    	organization_id () {
        return this.$route.params.organization_id;
      },
    },

    created () {
      Promise.all([ this.loadSignals() ])
	      .then(() => {
	        this.beforeRender();
	        this.isLoad = false;
	      })
	      .catch((e)=> {
	        console.log(e);
	      })
	      .finally(()=> {
	      	// to do все запросы выполненны
	        this.isLoad = false;
	      })
    },

    methods: {
    	
    	beforeRender () {
    		this.breadcrumbs = [
        	{name: this.$route.meta.name, link: this.$route.matched[0].path, ico: this.$route.meta.ico},
        	{name: this.address, link: ''},
        	{name: 'Сигналы', link: ''},
	      ];
    	},

  	  buildFilter () {
        const param = new URLSearchParams({});
        param.set("limit", this.limit);
        return param;
    	},

  	  async loadSignals () {
  	  	
	      this.isLoad = true;
        const param = this.buildFilter();
        
        const { signals, address, counter } = await this.$store.dispatch('getTrackerSignals', {house_id: this.house_id, data: param});
        this.signals = signals;
        this.address = address;
        this.counter = counter;
        this.maxSignalCategory = [];
        for (const type in this.signals) {
        	if(this.signals[type].length < this.limit) {
	      		this.maxSignalCategory.push(type);
	        }
        }
	      this.isLoad = false;
    	},


    	async uploading (e, status) {

    		let btn = null;

    		if(e !== null) {
    			btn = e.currentTarget;
    			btn.classList.add('btn--load');
    		}

        const param = this.buildFilter();

        param.set("status", status);
        param.set("limit", this.limitPreLoad);
        param.set("offset", this.signals[status].length);

        const { signals, counter } = await this.$store.dispatch('getTrackerSignals', {house_id: this.house_id, data: param});

        // Добавляем задачи в нужный раздел
        this.signals[status].push(...signals[status]);
        // Обновляем счётчики сверху
        this.counter = counter;
        this.isSelectAllAssigned = false;
        // будет ли еще дозагрузка по этой категории?
      	if(signals[status].length < this.limitPreLoad) {
      		this.maxSignalCategory.push(status);
      	}

    		if(e !== null) {
    			btn.classList.remove('btn--load');
    		}

    	},

    },

  }
</script>

<style scoped>


	.postponement {
		display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
	}

	.postponement:deep(.counter) {
		width: 50%;
		min-width: 100px;
	}
	.postponement .btn {
		width: 50%;
	} 




	.component-content {
		display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
	}
	.component-filter {
		background-color: var(--cozh-white);
		padding: 10px 10px;
		border-radius: 8px;
    position: relative;
/*    overflow-x: auto;*/
	}

	.component-filter__content {
		overflow: visible;
		display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
	}

	.component-filter__item {
/*  	flex: 1 1 20%;*/
		min-width: 130px;
    width: auto;
	}
	.component-filter__item:has(.range-picker) {
/*  		flex: 1 1 200px;*/
		min-width: 300px;
		width: 300px;
	}
	.component-filter__item .range-picker {
		width: auto;
	}
	.component-filter__item:deep(.custom-select) {
		height: 34px;
	}
	.component-filter__item:deep(.range-picker .calendar .calendar__control) {
		height: 32px;
	}


	.component-tasks {
		display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 5px;
    position: relative;
	}
	.component-tasks__item {
  	flex: 1 1 0;
    width: 0;
    position: relative;
	}
	.component-tasks__content {
    height: calc(100vh - 206px);
    overflow-y: auto;
    padding-right: 5px;
	}
	.component-tasks__content.fixed {
		padding-bottom: 70px;
	}
	.component-tasks__panel {
		position: absolute;
    bottom: 0px;
    left: 0;
    width: calc(100% - 14px);
    padding: 15px;
    background-color: #ffffff;
	}





	.component-headers {
		display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    position: relative;
	}

	.component-headers__item {
		flex: 1 1 0;
		width: 0;
		padding-right: 4px;
	}

	.component-header {
		background-color: var(--cozh-white);
    border-radius: 8px;
    padding: 7px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
	}


	.component-header__label {
		color: var(--cozh-grey);
	 	font-size: 11px;
		font-weight: 600;
	 	text-transform: uppercase;
		line-height: 1.3;
	 	letter-spacing: 0.55px;
	 	padding-left: 12px;
	 	position: relative;
	}

	.component-header__label::before {
		content: '';
		height: 5px;
		width: 5px;
		border-radius: 50%;
		position: absolute;
		left: 0px;
		top: 50%;
		transform: translateY(-50%);
	}

	.component-header__badge {
 		font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 4px 6px;
	}
	.component-header__group {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}
	.component-header--grey .component-header__badge,
	.component-header--grey .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-grey);
	}

	.component-header--blue .component-header__badge,
	.component-header--blue .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-blue);
	}

	.component-header--orange .component-header__badge,
	.component-header--orange .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-orange);
	}

	.component-header--red .component-header__badge,
	.component-header--red .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-red);
	}

	.component-header--darkred .component-header__badge,
	.component-header--darkred .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-dark-red);
	}

	.component-header--green .component-header__badge,
	.component-header--green .component-header__label::before {
		color: var(--cozh-white);
 		background-color: var(--cozh-green);
	}



	  .slide-enter-active {
    transition: all 0.2s ease-out;
  }
  .slide-leave-active {
    transition: all 0.2s ease-out;
  }
  .slide-leave-to {
    transform: translateY(30px);
    opacity: 0;
  }
  .slide-enter-from {
    transform: translateY(30px);
    opacity: 0;
  }



</style>